import BottomJSON from '@/static/build_by_you/Bottom.json';
import MiddleJSON from '@/static/build_by_you/Middle.json';
import TopJSON from '@/static/build_by_you/Top.json';
import { Box, Flex, useLottie } from '@lemonade-hq/cdk';
import type React from 'react';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

const SingleSpiral = styled(Box)`
  position: absolute;
  width: 100%;
`;

const Top = styled(SingleSpiral)`
  top: -20px;
  left: -1px;
  transform: scaleX(1.02);
`;

const Middle = styled(SingleSpiral)`
  right: -1px;
  transform: scaleX(1.02);
`;

const Bottom = styled(SingleSpiral)`
  bottom: -20px;
  transform: scaleX(1.02);
`;

const SpiralAnimation = styled(Flex)`
  position: absolute;
  top: 50%;
  left: -2px;
  right: -2px;
  height: 75%;
  width: 100%;
  transform: translateY(-50%) scaleX(1.1);
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Spiral: React.FC = () => {
  const topRef = useRef(null);
  const middleRef = useRef(null);
  const bottomRef = useRef(null);

  const topReference = useLottie(topRef, {
    animationData: TopJSON,
    lottieConfig: {
      loop: true,
    },
  });
  const middleReference = useLottie(middleRef, {
    animationData: MiddleJSON,
    lottieConfig: {
      loop: true,
    },
  });
  const bottomReference = useLottie(bottomRef, {
    animationData: BottomJSON,
    lottieConfig: {
      loop: true,
    },
  });

  useEffect(() => {
    if (topReference) topReference.play();
    if (middleReference) middleReference.play();
    if (bottomReference) bottomReference.play();
  }, [topReference, middleReference, bottomReference]);

  return (
    <SpiralAnimation>
      <Top ref={topRef} />
      <Middle ref={middleRef} />
      <Bottom ref={bottomRef} />
    </SpiralAnimation>
  );
};
